import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import useAccountDetail from '../../../hooks/queries/useAccountDetail'
import PageLoading from '../../../components/organisms/PageLoading'
import Description from '../../../components/molecules/Description'
import ErrorMessageFormat from '../../../components/molecules/ErrorMessageFormat'
import commaSeparator from '../../../utils/number'
import { roundDownFixedPoint, weiToEther } from '../../../utils/dataFormat'
import Button from '../../../components/atoms/Button'
import SymbolCard from '../../../components/molecules/SymbolCard'
import { ContentsDown, SymbolWrapper } from './styles'

function Overview() {
  const [showTokenHoldings, setShowTokenHoldings] = useState<boolean>(false)

  const { address } = useParams() as { address: string }
  const {
    isLoading,
    accountDetail = {
      address: '',
      nameTag: '',
      balance: '',
      symbol: '',
      tokenCount: 0,
      isContract: false,
      tokenHoldings: [],
    },
    isError,
  } = useAccountDetail(address)

  return (
    <>
      <PageLoading loading={isLoading} />
      <Description
        dataSource={[
          {
            title: 'Balance',
            desc: isError ? (
              <ErrorMessageFormat>
                <FormattedMessage id="error.failAccountBalance" />
              </ErrorMessageFormat>
            ) : (
              <>
                {commaSeparator(weiToEther(accountDetail.balance))}&nbsp;
                {accountDetail.symbol}
              </>
            ),
          },
          {
            title: 'Token',
            desc: isError ? (
              <ErrorMessageFormat>
                <FormattedMessage id="error.failAccountTokens" />
              </ErrorMessageFormat>
            ) : (
              <>Total {accountDetail.tokenCount} tokens</>
            ),
            suffix:
              accountDetail.tokenCount === 0 ? undefined : (
                <Button onClick={() => setShowTokenHoldings((prevState) => !prevState)} text="Token holdings" />
              ),
            suffixTheme: accountDetail.tokenCount === 0 ? undefined : 'downIcon',
          },
        ]}
      />

      {accountDetail.tokenHoldings === undefined || accountDetail.tokenHoldings[0] === null ? (
        ''
      ) : (
        <ContentsDown visible={showTokenHoldings}>
          <SymbolWrapper>
            {accountDetail.tokenHoldings.map((token) => (
              <SymbolCard
                key={token.tokenSymbol}
                name={token.name}
                value={token.tokenSymbol}
                balance={roundDownFixedPoint(weiToEther(token.tokenBalance))}
                symbolImg={token.imageUrl}
              />
            ))}
          </SymbolWrapper>
        </ContentsDown>
      )}
    </>
  )
}

export default Overview
